import { ContainerBody } from "../../../App";
import { Back2 } from "../../../components/Option/Back";
import "../index.css";
const CompanyContainer = ({ children }) => {
  return (
    <ContainerBody className="company__body">
      <div
        className="companydetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Company Page"}
          style={{
            marginRight: "auto",
            position: "relative",
            left: "-7%",
            zIndex: "9999",
          }}
          to={"/company"}
        />
      </div>
      {children}
    </ContainerBody>
  );
};

export default CompanyContainer;
